import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TransporUnitService {

  url: string = environment.urlBaseService

  constructor(private httpClient: HttpClient) { }

  GetTranposUnit(): Observable<any> {
    return this.httpClient.get<any>(`${this.url}TransportUnit`)
  }
}
